import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';
import * as Yup from 'yup';
import { PropertyCurrentlyPayingMortgageRuleset } from '../../pages/dashboard/loan_detail/flows/NewWelcomeFlow/business/ruleset/solar_property';
import { RulesetResult } from '../../pages/dashboard/loan_detail/flows/NewWelcomeFlow/business/rules';

const {
  formField: { systemPropertyCurrentlyPayingMortgage },
} = loanFormModel;

export class PropertyCurrentlyPayingMortgageValidation
  implements ValidationSchema
{
  public name: string = systemPropertyCurrentlyPayingMortgage.name;
  public label = '';
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = PropertyCurrentlyPayingMortgageRuleset;

  public when(schema: Yup.NumberSchema, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required) return schema.required('This field is required');

    return schema;
  }
}
export default new Validation(new PropertyCurrentlyPayingMortgageValidation());
